import { endpoints } from "@/config/endpoints";
import { apiService } from "@/services/apiService";

export default {
  getInvitationLink(payload) {
    return apiService.get(endpoints.invitationLink, { params: payload });
  }
};
